import { styled } from "styled-components";

export const MainContainer = styled.div`
    font-family: "DM Sans", normal;
`;
